<mat-form-field [appearance]="appearance" [hideRequiredMarker]="hideRequiredMarker">
    @if (label) {
        <mat-label>{{ label }}</mat-label>
    }

    @if (inputControl) {
        <input
            matInput
            [attr.aria-label]="ariaLabel"
            [attr.inputmode]="inputMode"
            [formControl]="inputControl"
            [placeholder]="placeholder"
            [readonly]="readonly"
            [type]="type"
            [value]="value"
            (keydown.enter)="handlePressEnter($event)" />
    } @else {
        <input
            matInput
            [attr.aria-label]="ariaLabel"
            [attr.inputmode]="inputMode"
            [disabled]="disabled"
            [placeholder]="placeholder"
            [readonly]="readonly"
            [type]="type"
            [value]="value" />
    }

    @if (prefixElement) {
        <button type="button" mat-icon-button matPrefix [disableRipple]="true" (click)="handlePrefixClick($event)">
            <ng-content select="[prefix]" />
        </button>
    }

    @if (suffixElement) {
        <button
            type="button"
            mat-icon-button
            matSuffix
            [disableRipple]="true"
            [matTooltip]="tooltip"
            (click)="handleSuffixClick($event)">
            <ng-content select="[suffix]" />
        </button>
    }

    @if (iconSuffix) {
        <span class="material-symbols-outlined me-3" matSuffix>
            {{ iconSuffix }}
        </span>
    }

    @if (iconPrefix) {
        <span class="material-symbols-outlined ms-3" matPrefix>
            {{ iconPrefix }}
        </span>
    }

    @if (showErrorMessage) {
        <mat-error>{{ inputControl?.errors | validationMessage }}</mat-error>
    }

    @if (hint) {
        <mat-hint>{{ hint }}</mat-hint>
    }
</mat-form-field>
